import PublicRoute from './PublicRoute'
import AccessRoute from './AccessRoute'
import routeConfig from '../configs/route.config'
import { lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { MainApp } from '../pages'
import GuestRoute from './GuestRoute'
import TaskDetailContext from '../context/task-detail.context'

const Router = () => {
  const Login = lazy(() => import('../pages/Login/Login'))
  const Team = lazy(() => import('../pages/Team/Team'))
  const Report = lazy(() => import('../pages/Report/Report'))
  const Notification = lazy(() => import('../pages/Notification/Notification'))
  const Invitation = lazy(() => import('../pages/Invitation/Invitation'))
  const FeedbackForm = lazy(() => import('../pages/FeedbackForm/FeedbackForm'))
  
  // Dashboard
  const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'))
  const PersonalDashboardRoot = lazy(() => import('../pages/PersonalDashboardRoot/PersonalDashboardRoot'))
  const AddOnDashboardRoot = lazy(() => import('../pages/AddOnDashboardRoot/AddOnDashboardRoot'))
  
  // Customer
  const CustomerSetting = lazy(() => import('../pages/CustomerSetting/CustomerSetting'))
  const CustomerCreate = lazy(() => import('../pages/CustomerCreate/CustomerCreate'))
  const MasterCustomer = lazy(() => import('../pages/MasterCustomer/MasterCustomer'))
  const CustomerAnalisis = lazy(() => import('../pages/CustomerAnalisis/CustomerAnalisis'))
  
  // Leads
  const LeadsMaster = lazy(() => import('../pages/Leads/LeadsMaster/LeadsMaster'))
  const LeadsDashboard = lazy(() => import('../pages/Leads/LeadsDashboard/LeadsDashboard'))
  const LeadsActivity = lazy(() => import('../pages/Leads/LeadsActivity/LeadsActivity'))
  const LeadsActivityResult = lazy(() => import('../pages/Leads/LeadDetail/components/TabSummary/DetailActivity/DetailActivityResult'))
  const LeadsSetting = lazy(() => import('../pages/Leads/LeadsSetting/LeadsSetting'))
  const LeadsCreate = lazy(() => import('../pages/Leads/LeadsCreate/LeadsCreate'))
  const LeadsImport = lazy(() => import('../pages/Leads/LeadsImport/LeadImport'))
  const LeadsDetail = lazy(() => import('../pages/Leads/LeadDetail/LeadDetail'))
  const LeadsEdit = lazy(() => import('../pages/Leads/LeadEdit/LeadEdit'))

  // Task
  const MasterTask = lazy(() => import('../pages/MasterTask/MasterTask'))
  const TaskType = lazy(() => import('../pages/TaskType/TaskType'))
  const TaskSetting = lazy(() => import('../pages/TaskSetting/TaskSetting'))
  const TaskCalendarView = lazy(() => import('../pages/TaskCalendarView/TaskCalendarView'))
  const TaskMonitoring = lazy(() => import('../pages/TaskMonitoring/TaskMonitoring'))
  const TaskAnalytics = lazy(() => import('../pages/TaskAnalytics/TaskAnalytics'))
  const TaskTabs = lazy(() => import('../pages/TaskMonitoring/actions/Tabs'))
  const CreateTask = lazy(() => import('../pages/CreateTask/CreateTask'))
  const EditTask = lazy(() => import('../pages/EditTask/EditTask'))
  const TaskRevise = lazy(() => import('../pages/TaskRevise/TaskRevise'))

  // Ticket
  const ManagementTicket = lazy(() => import('../pages/ManagementTicket/ManagementTicket'))
  const TicketDetail = lazy(() => import('../pages/TicketDetail/TicketDetail'))
  const ManagementTicketTab = lazy(() => import('../pages/ManagementTicket/Action/TicketTabs'))
  const SettingTicket = lazy(() => import('../pages/TicketSetting/TicketSetting'))

  // Member
  const MemberMaster = lazy(() => import('../pages/MemberMaster/MemberMaster'))
  const MemberDetail = lazy(() => import('../pages/MemberDetail/MemberDetail'))
  const MemberDetailItem = lazy(() => import('../pages/MemberDetail/MemberDetailPerson/MemberDetailPerson'))
  const MemberDetailEdit = lazy(() => import('../pages/MemberDetail/MemberDetailPerson/components/DetailEdit/DetailEdit'))
  const MemberGroup = lazy(() => import('../pages/MemberGroup/MemberGroup'))
  const MemberList = lazy(() => import('../pages/MemberList/MemberList'))
  const MemberSetting = lazy(() => import('../pages/MemberSetting/MemberSetting'))
  const FeedbackMember = lazy(() => import('../pages/FeedbackMember/FeedbackMember'))
  const InviteList = lazy(() => import('../pages/MemberMaster/components/InviteList/InviteList'))

  // Leave
  const LeaveApproval = lazy(() => import('../pages/LeaveApproval/LeaveApproval'))
  const LeaveSetting = lazy(() => import('../pages/LeaveSetting/LeaveSetting'))

  // Attendance
  const AttendanceSetting = lazy(() => import('../pages/AttendanceSetting/AttendanceSetting'))
  const AttendanceMonitoring = lazy(() => import('../pages/AttendanceMonitoring/AttendanceMonitoring'))

  // Cost perdin
  const CostPerdin = lazy(() => import('../pages/CostPerdin/CostPerdin'))
  const CreateCostPerdin = lazy(() => import('../pages/CreateCostPerdin/CreateCostPerdin'))
  const CostPerdinDetail = lazy(() => import('../pages/CostPerdinDetail/CostPerdinDetail'))

  // Tracking
  const Geofence = lazy(() => import('../pages/Geofence/Geofence'))
  const LastLocation = lazy(() => import('../pages/LastLocation/LastLocation'))
  const MemberJourney = lazy(() => import('../pages/MemberJourney/MemberJourney'))
  const MemberJourneyDetail = lazy(() => import('../pages/MemberJourneyDetail/MemberJourneyDetail'))

  // Pos
  const PosDashboard = lazy(() => import('../pages/Pos/Dashboard/Dashboard'))
  const PosMasterMenu = lazy(() => import('../pages/Pos/MasterMenu/MasterMenu'))
  const PosCommission = lazy(() => import('../pages/Pos/Commission/Commission'))
  const PosTransaction = lazy(() => import('../pages/Pos/Transaction/Transaction'))
  const MasterOutlet = lazy(() => import('../pages/MasterOutlet/MasterOutlet'))
  const MasterStore = lazy(() => import('../pages/MasterStore/MasterStore'))
  const MasterProduct = lazy(() => import('../pages/MasterProduct/MasterProduct'))
  const SettlementSettlement = lazy(() => import('../pages/Settlement/Settlement/Settlement'))
  // const MasterIngredient = lazy(() => import('../pages/MasterIngredient/MasterIngredient'))
  // const MasterRecipe = lazy(() => import('../pages/MasterRecipe/MasterRecipe'))

  // Sales order
  const SalesOrderProduct = lazy(() => import('../pages/SalesOrderProduct/SalesOrderProduct'))
  const SalesOrderTransaction = lazy(() => import('../pages/SalesOrderTransaction/Transaction'))
  const SalesOrderTransactionUpload = lazy(() => import('../pages/SalesOrderTransaction/TransactionUpload/TransactionUpload'))
  const SalesOrderSetting = lazy(() => import('../pages/SalesOrderSetting/Settings'))
  const SalesOrderCreateProduct = lazy(() => import('../pages/SalesOrderCreateProduct/SalesOrderCreateProduct'))
  const SalesOrderBulkUpload = lazy(() => import('../pages/SalesOrderBulkUpload/SalesOrderBulkUpload'))
  const SalesOrderBulkUpdate = lazy(() => import('../pages/SalesOrderBulkUpdate/SalesOrderBulkUpdate'))
  // const SalesOrderDashboard = lazy(() => import('../pages/SalesOrderDashboard/SalesOrderDashboard'))
  // const SalesOrderEditProduct = lazy(() => import('../pages/SalesOrderEditProduct/SalesOrderEditProduct'))
  // const SalesOrderTransactionCreate = lazy(() => import('../pages/SalesOrderTransaction/Create/Create'))
  // const SalesOrderTransactionProductDetail = lazy(() => import('../pages/SalesOrderTransaction/ProductDetail/ProductDetail'))
  // const SalesOrderTransactionCart = lazy(() => import('../pages/SalesOrderTransaction/Cart/Cart'))
  // const SalesOrderTransactionCheckout = lazy(() => import('../pages/SalesOrderTransaction/Checkout/Checkout'))

  // Team
  const TeamConfiguration = lazy(() => import('../pages/TeamConfiguration/TeamConfiguration'))
  const Bulletin = lazy(() => import('../pages/Bulletin/Bulletin'))
  const FormBulletin = lazy(() => import('../pages/Bulletin/components/FormBulletin/FormBulletin'))

  // Configuration
  const Lookup = lazy(() => import('../pages/Lookup/Lookup'))

  // Item
  const DashboardItem = lazy(() => import('../pages/Item/DashboardItem/DashboardItem'))
  const AddItem = lazy(() => import('../pages/AddItem/AddItem'))
  const ItemList = lazy(() => import('../pages/ItemList/ItemList'))

  // Cash advanced
  const CashAdvancedMaster = lazy(() => import('../pages/CashAdvancedMaster/CashAdvancedMaster'))
  const CashAdvancedTransaction = lazy(() => import('../pages/CashAdvancedTransaction/CashAdvancedTransaction'))

  // Builder
  const DashboardBuilder = lazy(() => import('../pages/DashboardBuilder/DashboardBuilder'))
  const BuilderReport = lazy(() => import('../pages/BuilderReport/BuilderReport'))
  const AppBuilder = lazy(() => import('../pages/AppBuilder/AppBuilder'))
  const AppBuilderCreate = lazy(() => import('../pages/AppBuilderCreate/AppBuilderCreate'))
  const AppBuilderLookup = lazy(() => import('../pages/AppBuilderLookup/AppBuilderLookup'))
  const AppBuilderLookupCreate = lazy(() => import('../pages/AppBuilderLookupCreate/AppBuilderLookupCreate'))
  const AppBuilderOption = lazy(() => import('../pages/AppBuilderOption/AppBuilderOption'))
  const AppBuilderOptionFormat = lazy(() => import('../pages/AppBuilderOptionFormat/AppBuilderOptionFormat'))
  const AppBuilderOptionPreview = lazy(() => import('../pages/AppBuilderOptionPreview/AppBuilderOptionPreview'))

  // Invoice
  const InvoiceDashboard = lazy(() => import('../pages/InvoiceDashboard/InvoiceDashboard'))
  const InvoiceMaster = lazy(() => import('../pages/InvoiceMaster/InvoiceMaster'))
  const InvoiceCreate = lazy(() => import('../pages/InvoiceCreate/InvoiceCreate'))
  const InvoiceDetail = lazy(() => import('../pages/InvoiceDetail/InvoiceDetail'))
  const InvoiceSetting = lazy(() => import('../pages/InvoiceSetting/InvoiceSetting'))

  // Inventory
  const InventoryAddItem = lazy(() => import('../pages/Inventory/AddItem/AddItem'))
  const InventoryMasterItem = lazy(() => import('../pages/Inventory/MasterItem/MasterItem'))
  const InventoryMasterCategory = lazy(() => import('../pages/Inventory/MasterCategory/MasterCategory'))
  const InventoryStockHistory = lazy(() => import('../pages/Inventory/StockHistory/StockHistory'))
  const InventoryUsage = lazy(() => import('../pages/Inventory/InventoryUsage/InventoryUsage'))
  const InventoryDashboard = lazy(() => import('../pages/Inventory/DashboardInventory/DashboardInventory'))
  const InventoryInventory = lazy(() => import('../pages/Inventory/Inventory/Inventory'))

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path={routeConfig.login} element={<Login />} />
      </Route>
      
      <Route element={<MainApp />}>
        <Route path={routeConfig.teams} element={<Team />} />
        <Route path={routeConfig.invitations} element={<Invitation />} />
        <Route path={routeConfig.notification} element={<Notification />} />

        {/* Dashboard */}
        <Route element={<AccessRoute access='1009' />}>
          <Route path={routeConfig.dashboardPersonalAddOn} element={<AddOnDashboardRoot />} />
          <Route path={routeConfig.dashboardPersonal} element={<PersonalDashboardRoot />} />
          <Route path={routeConfig.dashboard} element={<Dashboard />} />
        </Route>

        {/* Customer */}
        <Route element={<AccessRoute access='1008' />}>
          <Route path={routeConfig.customer.setting} element={<CustomerSetting />} />
          <Route path={routeConfig.customer.master} element={<MasterCustomer />} />
          <Route path={routeConfig.customer.analysis} element={<CustomerAnalisis />} />
        </Route>
        <Route path={routeConfig.customer.create} element={<CustomerCreate />} />
        <Route path={routeConfig.customer.edit} element={<CustomerCreate />} />

        {/* Leads */}
        <Route element={<AccessRoute access='1032' />}>
          <Route path={routeConfig.leads.master} element={<LeadsMaster />} />
          <Route path={routeConfig.leads.dashboard} element={<LeadsDashboard />} />
          <Route path={routeConfig.leads.activity} element={<LeadsActivity />} />
          <Route path={routeConfig.leads.setting} element={<LeadsSetting />} />
          <Route path={routeConfig.leads.import} element={<LeadsImport />} />
          <Route path={routeConfig.leads.create} element={<LeadsCreate />} />
          <Route path={routeConfig.leads.edit} element={<LeadsEdit />} />
          <Route path={routeConfig.leads.detail} element={<LeadsDetail />} />
          <Route path={routeConfig.leads.detailResult} element={<LeadsActivityResult />} />
        </Route>

        {/* Task */}
        <Route element={<AccessRoute access='1013' />}>
          <Route path={routeConfig.task.master} element={<MasterTask />} />
          <Route path={routeConfig.task.analysis} element={<TaskAnalytics />} />
          <Route path={routeConfig.task.setting} element={<TaskSetting />} />
        </Route>
        <Route element={<AccessRoute access='1003' />}>
          <Route path={routeConfig.task.type} element={<TaskType />} />
        </Route>
        <Route element={<AccessRoute access='1020' />}>
          <Route path={routeConfig.task.monitoring} element={<TaskMonitoring />} />
          <Route path={routeConfig.task.monitoringDetailResult} element={<TaskTabs />} />
        </Route>
        <Route path={routeConfig.task.create} element={<CreateTask />} />
        <Route path={routeConfig.task.edit} element={<EditTask />} />
        <Route path={routeConfig.task.calendar} element={<TaskCalendarView />} />
        <Route 
          path={routeConfig.task.revise} 
          element={
            <TaskDetailContext>
              <TaskRevise />
            </TaskDetailContext>
          } 
        />

        {/* Ticket */}
        <Route element={<AccessRoute access='1027' />}>
          <Route path={routeConfig.ticket.master} element={<ManagementTicket />} />
          <Route path={routeConfig.ticket.detail} element={<TicketDetail />} />
          <Route path={routeConfig.ticket.detail} element={<ManagementTicketTab />} />
          <Route path={routeConfig.ticket.setting} element={<SettingTicket />} />
        </Route>

        {/* Member */}
        <Route element={<AccessRoute access='1017' />}>
          <Route path={routeConfig.member.master} element={<MemberMaster />} />
          <Route path={routeConfig.member.detail} element={<MemberDetail />} />
          <Route path={routeConfig.member.detailById} element={<MemberDetailItem />} />
          <Route path={routeConfig.member.edit} element={<MemberDetailEdit />} />
          <Route path={routeConfig.member.group} element={<MemberGroup />} />
          <Route path={routeConfig.member.list} element={<MemberList />} />
          <Route path={routeConfig.member.inviteList} element={<InviteList />} />
        </Route>
        <Route element={<AccessRoute access='1023' />}>
          <Route path={routeConfig.member.setting} element={<MemberSetting />} />
        </Route>
        <Route element={<AccessRoute access='1024' />}>
          <Route path={routeConfig.member.feedback} element={<FeedbackMember />} />
        </Route>

        {/* Leave */}
        <Route element={<AccessRoute access='1025' />}>
          <Route path={routeConfig.leave.approval} element={<LeaveApproval />} />
        </Route>
        <Route element={<AccessRoute access='1026' />}>
          <Route path={routeConfig.leave.setting} element={<LeaveSetting />} />
        </Route>

        {/* Attendance */}
        <Route element={<AccessRoute access='1021' />}>
          <Route path={routeConfig.attendance.monitoring} element={<AttendanceMonitoring />} />
        </Route>
        <Route element={<AccessRoute access='1022' />}>
          <Route path={routeConfig.attendance.setting} element={<AttendanceSetting />} />
        </Route>

        {/* Cost Perdin */}
        <Route element={<AccessRoute access='1033' />}>
          <Route path={routeConfig.costPerdin.master} element={<CostPerdin />} />
          <Route path={routeConfig.costPerdin.create} element={<CreateCostPerdin />} />
          <Route path={routeConfig.costPerdin.detail} element={<CostPerdinDetail />} />
        </Route>

        {/* Tracking */}
        <Route element={<AccessRoute access='1037' />}>
          <Route path={routeConfig.tracking.geofence} element={<Geofence />} />
        </Route>
        <Route element={<AccessRoute access='4' />}>
          <Route path={routeConfig.tracking.location} element={<LastLocation />} />
        </Route>
        <Route element={<AccessRoute access='3' />}>
          <Route path={routeConfig.tracking.journey} element={<MemberJourney />} />
          <Route path={routeConfig.tracking.journeyDetail}  element={<MemberJourneyDetail />} />
        </Route>

        {/* Pos */}
        <Route element={<AccessRoute access='1028' />}>
          <Route path={routeConfig.pos.masterOutlet} element={<MasterStore />} />
        </Route>
        <Route element={<AccessRoute access='1029' />}>
          <Route path={routeConfig.pos.masterMitra} element={<MasterOutlet />} />
        </Route>
        <Route element={<AccessRoute access='1030' />}>
          <Route path={routeConfig.pos.masterProduct} element={<MasterProduct />} />
        </Route>
        <Route element={<AccessRoute access='1031' />}>
          <Route path={routeConfig.pos.settlement} element={<SettlementSettlement />} />
          <Route path={routeConfig.pos.dashboard} element={<PosDashboard />} />
          <Route path={routeConfig.pos.masterMenu} element={<PosMasterMenu />} />
          <Route path={routeConfig.pos.commission} element={<PosCommission />} />
          <Route path={routeConfig.pos.transaction} element={<PosTransaction />} />
        </Route>

        {/* Sales order */}
        <Route element={<AccessRoute access='1035' />}>
          <Route path={routeConfig.salesOrder.product} element={<SalesOrderProduct />} />
          <Route path={routeConfig.salesOrder.transaction} element={<SalesOrderTransaction />} />
          <Route path={routeConfig.salesOrder.transactionUpload} element={<SalesOrderTransactionUpload />} />
          <Route path={routeConfig.salesOrder.setting} element={<SalesOrderSetting />} />
          <Route path={routeConfig.salesOrder.productCreate} element={<SalesOrderCreateProduct />} />
          <Route path={routeConfig.salesOrder.productUpdate} element={<SalesOrderCreateProduct />} />
          <Route path={routeConfig.salesOrder.productBulkUpload} element={<SalesOrderBulkUpload />} />
          <Route path={routeConfig.salesOrder.productBulkUpdate} element={<SalesOrderBulkUpdate />} />
          {/* <Route path={urlRouter.SALES_ORDER_DASHBOARD} element={<SalesOrderDashboard />} />
          <Route element={<SalesOrderTransactionLayout />}>
            <Route path={urlRouter.SALES_ORDER_TRANSACTION_CREATE} element={<SalesOrderTransactionCreate />} />
            <Route path={urlRouter.SALES_ORDER_TRANSACTION_PRODUCT_DETAIL} element={<SalesOrderTransactionProductDetail />} />
            <Route path={urlRouter.SALES_ORDER_TRANSACTION_CART} element={<SalesOrderTransactionCart />} />
            <Route path={urlRouter.SALES_ORDER_TRANSACTION_CHECKOUT} element={<SalesOrderTransactionCheckout />} />
          </Route> */}
        </Route>

        {/* Team */}
        <Route element={<AccessRoute access='1009' />}>
          <Route path={routeConfig.team.team} element={<TeamConfiguration />} />
        </Route>
        <Route element={<AccessRoute access='1001' />}>
          <Route path={routeConfig.bulletin.master} element={<Bulletin />} />
          <Route path={routeConfig.bulletin.create} element={<FormBulletin />} />
          <Route path={routeConfig.bulletin.edit} element={<FormBulletin />} />
        </Route>

        {/* Report */}
        <Route element={<AccessRoute access='1001' />}>
          <Route path={routeConfig.report} element={<Report />} />
        </Route>

        {/* Configuration */}
        <Route element={<AccessRoute access='1012' />}>
          <Route path={routeConfig.configuration.lookupList} element={<Lookup />} />
        </Route>

        {/* Builder */}
        <Route element={<AccessRoute access='1016' />}>
          <Route path={routeConfig.builder.report} element={<BuilderReport />} />
          <Route path={routeConfig.builder.dashboard} element={<DashboardBuilder />} />
          <Route path={routeConfig.builder.app} element={<AppBuilder />} />
          <Route path={routeConfig.builder.appCreate} element={<AppBuilderCreate />} />
          <Route path={routeConfig.builder.appEdit} element={<AppBuilderCreate />} />
          <Route path={routeConfig.builder.appLookup} element={<AppBuilderLookup />} />
          <Route path={routeConfig.builder.appLookupCreate} element={<AppBuilderLookupCreate />} />
          <Route path={routeConfig.builder.appLookupEdit} element={<AppBuilderLookupCreate />} />
          <Route path={routeConfig.builder.appOptionEdit} element={<AppBuilderOption />} />
          <Route path={routeConfig.builder.appOptionFormat} element={<AppBuilderOptionFormat />} />
          <Route path={routeConfig.builder.appOptionPreview} element={<AppBuilderOptionPreview />} />
        </Route>

        {/* Cash advance */}
        <Route element={<AccessRoute access='1014' />}>
          <Route path={routeConfig.cashAdvance.master} element={<CashAdvancedMaster />} />
        </Route>
        <Route element={<AccessRoute access='1015' />}>
          <Route path={routeConfig.cashAdvance.transaction} element={<CashAdvancedTransaction />} />
        </Route>
        
        {/* Item */}
        <Route element={<AccessRoute access='1013' />}>
          <Route path={routeConfig.item.dashboard} element={<DashboardItem />} />
          <Route path={routeConfig.item.list} element={<ItemList />} />
          <Route path={routeConfig.item.create} element={<AddItem />} />
        </Route>

        {/* Invoice */}
        <Route element={<AccessRoute access='1013' />}>
          <Route path={routeConfig.invoice.dashboard} element={<InvoiceDashboard />} />
          <Route path={routeConfig.invoice.master} element={<InvoiceMaster />} />
          <Route path={routeConfig.invoice.create} element={<InvoiceCreate />} />
          <Route path={routeConfig.invoice.detail} element={<InvoiceDetail />} />
          <Route path={routeConfig.invoice.setting} element={<InvoiceSetting />} />
        </Route>

        {/* Inventory */}
        <Route element={<AccessRoute access='1013' />}>
          <Route path={routeConfig.inventory.dashboard} element={<InventoryDashboard />} />
          <Route path={routeConfig.inventory.masterItem} element={<InventoryMasterItem />} />
          <Route path={routeConfig.inventory.masterCategory} element={<InventoryMasterCategory />} />
          <Route path={routeConfig.inventory.usage} element={<InventoryUsage />} />
          <Route path={routeConfig.inventory.stockHistory} element={<InventoryStockHistory />} />
          <Route path={routeConfig.inventory.addItem} element={<InventoryAddItem />} />
          <Route path={routeConfig.inventory.inventory} element={<InventoryInventory />} />
        </Route>
      </Route>

      <Route element={<GuestRoute />}>
        <Route path={routeConfig.feedbackForm} element={<FeedbackForm />} />
      </Route>
    </Routes>
  )
}

export default Router